import Image from "next/image";

import useSWR from "swr";
import { repository } from "repositories";
import {
  GetFreeFortuneKanteiParams,
  GetFreeFortuneKanteiRes,
  SWRResponse,
} from "shared/types";
import { eventAction, eventName, useGaEvent } from "shared/hooks/useGaEvent";
import { useTarotCardModal } from "features/無料占いコンテンツ/hooks/useTarotCardModal";
import { Scrollable } from "shared/hooks/useScroll";

export const useFreeFortuneKantei = (
  params: GetFreeFortuneKanteiParams
): SWRResponse<GetFreeFortuneKanteiRes> => {
  const repo = repository.freeFortuneKantei.getObject(params);
  const { data, error, mutate } = useSWR(repo.path, repo.data);

  return {
    freeFortuneResultContent: data?.freeFortuneResultContent,
    isLoading: !data && !error,
    isError: !!error,
    mutate,
  };
};

interface Props {
  contentId: string | number;
  className?: string;
}

export const Tarot1 = ({ className }: Props) => {
  const { showModal } = useTarotCardModal();

  const { sendEvent } = useGaEvent();

  const onClick = () => {
    sendEvent({
      eventName: eventName.freeFortune,
      eventAction: eventAction.freeFortune.tarotButtonClick,
    });
    showModal();
  };

  return (
    <Scrollable name="tarot" className={className}>
      <section>
        <p
          tw="font-brush text-[26px] tracking-[.24px] leading-8 text-grape text-center"
          css={{ transform: "rotate(-4deg)" }}
        >
          Tarot Reading
        </p>
        <h3 tw="font-bold text-[22px] leading-7 tracking-[.2px] text-center mt-2">
          お好きなタロットカードを
          <br />
          一枚選んでください
        </h3>

        <ul tw="grid grid-flow-col relative mt-8">
          {[...Array(8)].map((_, index) => (
            <li
              key={`tarot-group-a-${index}`}
              tw="pr-1.5 animate-infinity-scroll-l"
            >
              <button onClick={onClick}>
                <Image
                  src={"/media/images/free_fortune/tarot_1_card_4.png"}
                  width={91}
                  height={170}
                  alt={`タロットカードのイメージ画像${index + 1}`}
                  layout="fixed"
                />
              </button>
            </li>
          ))}
        </ul>
        <ul tw="grid grid-flow-col relative">
          {[...Array(8)].map((_, index) => (
            <li
              key={`tarot-group-b-${index}`}
              tw="pr-1.5 animate-infinity-scroll-r"
            >
              <button onClick={onClick}>
                <Image
                  src={"/media/images/free_fortune/tarot_1_card_4.png"}
                  width={91}
                  height={170}
                  alt={`タロットカードのイメージ画像${index + 9}`}
                  layout="fixed"
                />
              </button>
            </li>
          ))}
        </ul>
      </section>
    </Scrollable>
  );
};
